
import { LightningElement, api, track } from 'lwc';


const CL_STYLES = [
    ['boxShadow', '.gw-card', 'card-shadow']
];

export default class gwCard extends LightningElement {
    //static renderMode = 'light';


    @api 
    set boxShadow(value) {
        this._boxShadow = value;
    } 
    get boxShadow() {
        return this._boxShadow;
    }


    renderedCallback() {
        this._applyClassVars();
    }


    // Call this function in renderedCallback  --> e.g. renderedCallback() {this.applyVars();}
    _clStylesApplied = false;
    // Apply Styles to the host
    _applyClassVars() {
        if (this._clStylesApplied) return;
        
        CL_STYLES.forEach(styleArr => {
            if (this[styleArr?.[0]] && styleArr?.[1] && styleArr?.[2]) {
                const ele = this.template.querySelector(styleArr[1]);
                if (ele) {
                    ele.classList.add(styleArr[2]);
                }
            }
        });

    }
}